import { render } from "./city-attachment.vue?vue&type=template&id=4d23bbab"
import script from "./city-attachment.vue?vue&type=script&lang=js"
export * from "./city-attachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__